import { useMutation } from 'react-query'
import { api } from '../../../api'

const removeClient = (id: number) => {
  return api.delete(`/clients/${id}`)
}

export const useClientRemoveMutation = () => {
  return useMutation('remove-client', {
    mutationFn: (id: number) => {
      return removeClient(id)
    },
  })
}
